import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useBackendStatus } from '../../hooks/useBackendApi';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { usingBackend, checking } = useBackendStatus();
  const location = useLocation();

  if (checking || authLoading) return null;
  if (!usingBackend) return <Outlet />;
  if (isAuthenticated) return <Outlet />;
  return <Navigate to="/login" state={{ from: location }} replace />;
}
